import type { CalendarBase } from "./calendar-base";
import type { CalendarProps } from "../calendar";
import type { CalendarContextValue } from "../context/calendar/calendar-context";
import type { Dispatch, SetStateAction } from "react";

export interface CalendarSingleProps extends CalendarBase {
	mode: "single";
	selected: string;
	onSelect: Dispatch<SetStateAction<string>>;
}

export function isDayPickerSingle(
	props: CalendarProps | CalendarContextValue, //
): props is CalendarSingleProps {
	return props.mode === "single";
}
